"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var use_default_1 = require("../_util/use-default");
var icon_1 = require("../icon");
var transition_1 = require("../transition");
var config_context_1 = require("../_util/config-context");
var button_1 = require("../button");
var AlertNotice_1 = require("./AlertNotice");
var i18n_1 = require("../i18n");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var util_1 = require("../util");
var uuid_1 = require("../_util/uuid");
var iconMap = {
    info: "infoblue",
    success: "success",
    warning: "warning",
    error: "error",
};
exports.Alert = forward_ref_with_statics_1.forwardRefWithStatics(function Alert(_a, ref) {
    var _b;
    var type = _a.type, children = _a.children, className = _a.className, onClose = _a.onClose, extra = _a.extra, hideIcon = _a.hideIcon, carouselMode = _a.carouselMode, _c = _a.interval, interval = _c === void 0 ? 5000 : _c, _visible = _a.visible, _defaultVisible = _a.defaultVisible, props = tslib_1.__rest(_a, ["type", "children", "className", "onClose", "extra", "hideIcon", "carouselMode", "interval", "visible", "defaultVisible"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var t = i18n_1.useTranslation();
    var _d = tslib_1.__read(use_default_1.useDefault(_visible, _defaultVisible, function (visible) { return !visible && onClose && onClose(); }), 2), visible = _d[0], onVisibleChange = _d[1];
    var isClosable = typeof visible === "boolean";
    var timerRef = react_1.useRef(null);
    var _e = tslib_1.__read(react_1.useState(0), 2), currentIndex = _e[0], setCurrentIndex = _e[1];
    var length = react_1.default.Children.toArray(children).filter(Boolean).length;
    var circulate = react_1.useCallback(function () {
        if (!carouselMode) {
            return;
        }
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(function () {
            setCurrentIndex(function (i) { return (i + 1) % length; });
            circulate();
        }, interval);
    }, [carouselMode, interval, length]);
    react_1.useEffect(function () {
        circulate();
        return function () { return clearTimeout(timerRef.current); };
    }, [circulate]);
    var _f = tslib_1.__read(react_1.useState(uuid_1.uuid()), 2), id = _f[0], setId = _f[1];
    react_1.useEffect(function () {
        setId(uuid_1.uuid());
    }, [children]);
    var alertClassName = classnames_1.default(classPrefix + "-alert", (_b = {},
        _b[classPrefix + "-alert--" + type] = type,
        _b), className);
    var alertElement = function (children) {
        var _a, _b;
        return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: alertClassName }, props, { onMouseEnter: util_1.callBoth(function () {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
            }, (_a = props) === null || _a === void 0 ? void 0 : _a.onMouseEnter), onMouseLeave: util_1.callBoth(circulate, (_b = props) === null || _b === void 0 ? void 0 : _b.onMouseLeave) }),
            !hideIcon && (react_1.default.createElement("span", { className: classPrefix + "-alert__decoration" },
                react_1.default.createElement(icon_1.Icon, { type: iconMap[type] || "infoblue" }))),
            react_1.default.createElement("div", { className: classPrefix + "-alert__info" }, children),
            react_1.default.createElement("div", { className: classPrefix + "-alert__operational" },
                extra,
                carouselMode && (react_1.default.createElement(Dot, { classPrefix: classPrefix, total: length, currentIndex: currentIndex, onChange: function (index) {
                        setCurrentIndex(index);
                        circulate();
                    } })),
                isClosable && (react_1.default.createElement(button_1.Button, { type: "icon", icon: "close", htmlType: "button", onClick: function () { return onVisibleChange(false); }, "aria-label": t.closeText })))));
    };
    var content = !carouselMode
        ? alertElement(children)
        : alertElement(react_1.default.Children.toArray(children)
            .filter(Boolean)
            .map(function (c, i) { return (react_1.default.createElement("div", { key: id + "-" + i, style: i === currentIndex ? undefined : { display: "none" } }, c)); }));
    if (isClosable) {
        return react_1.default.createElement(transition_1.FadeTransition, { in: visible }, content);
    }
    return content;
}, {
    Notice: AlertNotice_1.AlertNotice,
});
exports.Alert.displayName = "Alert";
function Dot(_a) {
    var classPrefix = _a.classPrefix, total = _a.total, currentIndex = _a.currentIndex, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: classPrefix + "-alert__nav " + classPrefix + "-alert__nav--dot" }, Array(total)
        .fill(null)
        .map(function (_, i) { return (react_1.default.createElement("span", { key: i, className: classnames_1.default(classPrefix + "-alert__nav-item", {
            "is-current": currentIndex === i,
        }), onClick: function () { return onChange(i); } })); })));
}
//# sourceMappingURL=Alert.js.map